var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBakeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.0384H22.8673C22.5071 10.89 18.3809 6.76382 13.2324 6.40361V4.66455H11.7676V6.40361C6.61914 6.76382 2.49292 10.89 2.13271 16.0385H0V17.5033H1.50732L2.97217 20.336H22.1255L23.5903 17.5033H25V16.0384ZM12.5 7.84229C17.1765 7.84229 21.0249 11.4566 21.3988 16.0384H3.60117C3.9751 11.4566 7.82349 7.84229 12.5 7.84229ZM21.2339 18.8711H3.86377L3.15645 17.5033H21.9413L21.2339 18.8711Z",
    fill: "#B9BCBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBakeIcon);
export default __webpack_public_path__ + "static/media/bake-icon.01b1cfbf.svg";
export { ForwardRef as ReactComponent };